
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trash2, Download } from "lucide-react";
import type { Invitation } from "./hooks/useResourceInvitations";

interface InvitationListProps {
  invitations: Invitation[];
  onRevokeInvite: (inviteId: string) => Promise<void>;
  onDownloadCertificate: (email: string) => Promise<void>;
}

export function InvitationList({ 
  invitations, 
  onRevokeInvite, 
  onDownloadCertificate 
}: InvitationListProps) {
  if (!invitations.length) {
    return null;
  }

  return (
    <div className="mb-4 rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Email</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Progress</TableHead>
            <TableHead className="">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invitations.map(invite => (
            <TableRow key={invite.id}>
              <TableCell className="text-sm">{invite.email}</TableCell>
              <TableCell className="text-sm capitalize">{invite.status}</TableCell>
              <TableCell className="text-sm">
                {invite.status === 'accepted' && invite.progress !== undefined ? `${invite.progress}%` : '-'}
              </TableCell>
              <TableCell className="flex items-center justify-end space-x-2">
                {invite.status === 'accepted' && invite.progress === 100 && invite.completed && (
                  <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={() => onDownloadCertificate(invite.email)} 
                    className="h-8 w-8" 
                    title="Download Certificate"
                  >
                    <Download className="h-4 w-4 text-muted-foreground hover:text-primary" />
                  </Button>
                )}
                <Button 
                  variant="ghost" 
                  size="icon" 
                  onClick={() => onRevokeInvite(invite.id)} 
                  className="h-8 w-8" 
                  title="Remove from Training"
                >
                  <Trash2 className="h-4 w-4 text-muted-foreground hover:text-destructive" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="text-xs text-muted-foreground p-2 border-t">
        <p>Actions:</p>
        <ul className="list-disc list-inside ml-2">
          <li>Download certificate (available when training is completed)</li>
          <li>Remove trainee from this resource</li>
        </ul>
      </div>
    </div>
  );
}
